import { toIsoWithTimezoneString } from '../formatter/dateFormatter';

const COOKIE_GROUPS = 'groups=' + encodeURIComponent('C0001:' + 0 + ','
  + 'C0002:' + 0 + ','
  + 'C0003:' + 0 + ','
  + 'C0004:' + 1 + ','
  + 'C0005:' + 0);

const OPT_OUT_COOKIE_NAME = 'OptOutOnRequest';
const HUNDRED_YEARS_IN_DAYS = 36525;
const HD_PRIVACY_OPT_OUT = 'HDPrivacyOptOut';

function stripSubDomains(domain = '') {
  let parentDomain = domain;

  let domainParts = domain.split('.');
  let length = domainParts.length;
  if (length > 1) {
    parentDomain = domainParts[length - 2] + '.' + domainParts[length - 1];
  }
  return parentDomain;
}

function buildCookieScope(domain = '') {
  return domain
    ? '; domain=' + domain
    : '';
}

function buildCookieTimestamp() {
  return 'datetimestamp=' + encodeURIComponent(toIsoWithTimezoneString(new Date(Date.now())));
}

function buildCookieSettings(domain = '') {
  return buildCookieTimestamp() + '&'
    + COOKIE_GROUPS
    + buildCookieScope(domain);
}

function createOptOutCookie(cookieCallback, domain) {
  cookieCallback(OPT_OUT_COOKIE_NAME, buildCookieSettings(domain), HUNDRED_YEARS_IN_DAYS);
}
function createLocalStorageKey() {
  if (typeof Storage !== 'undefined') {
    localStorage.setItem(HD_PRIVACY_OPT_OUT, 'On');
  }
}

export function createOptOutCookies(cookieCallback, domain = '') {
  createOptOutCookie(cookieCallback);
  createOptOutCookie(cookieCallback, stripSubDomains(domain));
  createLocalStorageKey();
}
